module.exports = __webpack_public_path__ + "img/asia_mission_1.d7566bfe.jpg";